import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M10.5,7.5 L16.5,7.5 C17.328,7.5 18,8.172 18,9 C18,9.828 17.328,10.5 16.5,10.5 L10.5,10.5 L10.5,16.5 C10.5,17.328 9.828,18 9,18 C8.172,18 7.5,17.328 7.5,16.5 L7.5,10.5 L1.5,10.5 C0.672,10.5 0,9.828 0,9 C0,8.172 0.672,7.5 1.5,7.5 L7.5,7.5 L7.5,1.5 C7.5,0.672 8.172,0 9,0 C9.828,0 10.5,0.672 10.5,1.5 L10.5,7.5 Z"
      transform="translate(3 3)"
      fill={fill}
    />
  </g>
);

export default Icon;
